import React from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import HomePage from './Pages/HomePage';
import GamePage from './Pages/GamesPage';
import LoginPage from './Pages/LoginPage';
import SubscribePage from './Pages/SubscribePage';
import ConfirmationPage from './Pages/ConfirmationPage';
import SubscriptionPendingPage from './Pages/SubscriptionPendingPage';
import PrivacyPolicy from './Pages/PrivacyPolicy';
import ProtectedRoute from './middleware/ProtectedRoute';

const App = () => {
  const router = createBrowserRouter([
    {

      path: "/",
       element: (
        <ProtectedRoute>
          <HomePage />
        </ProtectedRoute>
      )
    },
    {
      path: "/login",
      element: <LoginPage />
    },
    {
      path: "/subscribe",
      element: <SubscribePage />
    },
    {
      path: "/privacy-policy",
      element: <PrivacyPolicy />
    },
    {
      path: "/confirmation",
      element: <ConfirmationPage />
    },
    {
      path: "/subscribe/waiting",
      element: <SubscriptionPendingPage />
    },
    {
       
     path: "/games/:id/:name",
      element: (
        <ProtectedRoute>
          <GamePage />
        </ProtectedRoute>
      )
    },
    
    // {
    //   path: "*",
    //   element: <Navigate to="/" />
    // }
  ]);

  return (
    <RouterProvider router={router} />
    
  );
};

export default App;